var React = require('react');

function FacebookIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.1241 0H1.27912C0.70197 0 0.233887 0.46968 0.233887 1.0488V17.9512C0.233887 18.5303 0.70197 19 1.27912 19H10.3477V11.6424H7.88001V8.77496H10.3477V6.65988C10.3477 4.20584 11.8413 2.86976 14.0234 2.86976C15.0687 2.86976 15.967 2.94804 16.2283 2.983V5.548L14.7149 5.54876C13.5281 5.54876 13.2986 6.1142 13.2986 6.94488V8.77572H16.1283L15.7594 11.6432H13.2978V19H18.1241C18.7012 19 19.1693 18.5303 19.1693 17.9512V1.0488C19.1693 0.46968 18.7012 0 18.1241 0Z","fill":"black"}));
}

FacebookIconInline.defaultProps = {"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none","className":"svg"};

module.exports = FacebookIconInline;

FacebookIconInline.default = FacebookIconInline;
